import React from "react";
function MissionAndVisionCards() {
  const data = [
    {
      title: "Mission",
      description:
        " Vardhman Charitable Trust provides transformative and experimental learning experiences in a socially responsible, anchored by its core values and ethics which promotes academic excellence, inspires innovation and entrepreneurship, foster an agile mindset and prepares graduate and post graduate to contribute to a globe society that is fully focus on change.",
    },
    {
      title: "Vision",
      description:
        "Vardhman Charitable Trust will flourish and recognize as a national institute for innovative, creative and skill base education for the betterment of next generation. We will educate our students and contribute in national building. We want to create bright future of nation by educating current generation.",
    },
  ];
  return (
    <div className="flex items-center justify-center mb-5">
      <div className="grid  grid-cols-1 md:grid-cols-2 gap-6 items-start justify-center  max-w-6xl">
        {data.map((e, index) => {
          return (
            <div
              key={index}
              className="relative bg-primary h-full flex flex-col items-start justify-between shadow-xl overflow-auto"
            >
              <div className="h-16 md:h-20 w-full bg-[#f9f5f2]"></div>
              <div className="absolute bg-white top-12 md:top-14 left-1/2 transition-all -translate-x-1/2 uppercase space-x-4 p-4 w-4/5 md:w-3/4 shadow-lg">
                <span className="text-black font-medium">Our</span>
                <span className="text-2xl md:text-3xl text-secondary font-semibold">
                  {e?.title}
                </span>
              </div>
              <div className="p-4 mt-16 md:mt-20">
                <p className="text-white text-sm md:text-base text-justify p-2">
                  {e?.description}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default MissionAndVisionCards;
